<template>
	<layout-admin>
		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			v-bind:row-href="rowHref"
			defaultOrderBy="release_at"
			:defaultOrderByAscending="false"
			:showActionButton="true"
			:actionButtonCaption="'Create'"
			:actionButtonTarget="createUrl"
		/>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			title: this.__("Marktkompass"),
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "title",
					name: this.__("Title"),
				},
				{
					id: "release_at",
					name: this.__("Release at"),
					render: (c) => options.formatIsoStamp(c),
				},
				{
					id: "user_id",
					name: this.__("User ID"),
				},
				{
					id: "created_at",
					name: this.__("Created"),
					render: (c) => options.formatIsoStamp(c),
				},
			],
		};
	},
	computed: {
		createUrl() {
			return window.baseUrl + "/admin/market-news/create";
		},
	},
	methods: {
		rowHref(row) {
			return window.baseUrl + "/admin/market-news/" + row.id.replace("#", "");
		},
	},
};
</script>
